<template>
  <nav
    aria-label="menu"
    class="bg-surface-default-low fixed inset-0 z-20 flex flex-col md:hidden"
  >
    <NavBurgerMenuHeader @close="toggle" />
    <div
      v-if="isPostalCodePromiseEnabled"
      class="bg-surface-default-hi flex items-center justify-between px-24 py-8"
    >
      <CountrySwitchMenuFullScreen variant="chip" />
      <DeliveryPostalCodeTrigger entry-point="nav" tracking-context="mweb" />
      <DeliveryPostalCodeModal entry-point="nav" tracking-context="mweb" />
    </div>
    <!-- eslint-disable-next-line tailwindcss/no-custom-classname -->
    <div class="flex-1 overflow-auto py-20 scrollable">
      <NavBurgerMenuItemList />
      <NavBurgerMenuFooter @click-item="toggle" />
    </div>
    <div
      v-if="!isPostalCodePromiseEnabled"
      class="border-static-default-low flex items-center gap-8 border-t px-20 py-12"
    >
      <CountrySwitchMenuFullScreen :compact="showLanguageSwitchLinks" />
      <LanguageSwitchLinks v-if="showLanguageSwitchLinks" />
    </div>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { isEsUsLocaleSelectorEnabled } from '~/scopes/navigation/utils/isEsUsLocaleSelectorEnabled'
import DeliveryPostalCodeModal from '~/scopes/shipping/components/DeliveryPostalCodeModal/DeliveryPostalCodeModal.vue'
import DeliveryPostalCodeTrigger from '~/scopes/shipping/components/DeliveryPostalCodeModal/DeliveryPostalCodeTrigger.vue'

import { useBurgerMenuState } from '../../composables/useBurgerMenuState'
import CountrySwitchMenuFullScreen from '../CountrySwitch/CountrySwitchMenuFullScreen.vue'
import LanguageSwitchLinks from '../CountrySwitch/LanguageSwitchLinks.vue'

import NavBurgerMenuFooter from './NavBurgerMenuFooter.vue'
import NavBurgerMenuHeader from './NavBurgerMenuHeader.vue'
import NavBurgerMenuItemList from './NavBurgerMenuItemList.vue'

const { toggle } = useBurgerMenuState()
const experiments = useExperiments()

const isPostalCodePromiseEnabled = computed(
  () => experiments['experiment.postalCodePromise'] === 'postalCodeEnabled',
)

const { market } = useMarketplace()

const showLanguageSwitchLinks =
  market.locales.length > 1 &&
  isEsUsLocaleSelectorEnabled(
    experiments['experiment.enableEsUsLocaleSelector'],
    market.countryCode,
  )
</script>
